import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
import "./registerServiceWorker";
import axios from "axios";
import VueLogger from "vuejs-logger";
import mql from "./plugins/mql.js";
import VueLocalStorage from "vue-localstorage";
import VueSweetalert2 from 'vue-sweetalert2';

import {
  loadLanguageAsync,
  i18n
} from "./setup/i18n-setup.js";
import "../public/assets/plugins/font-awesome/css/font-awesome.css";
import "../public/assets/plugins/materialdesignicons/css/materialdesignicons.min.css";
import "../public/assets/plugins/linearicons/linearicons.css";
import "../public/assets/plugins/bootstrap-4.1.2-dist/css/bootstrap.min.css";
import '../public/assets/styles/css/template.css'
import BootstrapVue from 'bootstrap-vue'
import Vuebar from 'vuebar';
import Toasted from 'vue-toasted';

import Chartkick from 'chartkick'
import VueChartkick from 'vue-chartkick'
import 'chart.js'
import 'hchs-vue-charts'
import mqlOptions from './plugins/mqlOptions.js'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog';
import '../public/assets/plugins/bootstrap-4.1.2-dist/css/bootstrap.min.css'
import {
  Laue
} from 'laue';
import JsonExcel from 'vue-json-excel'

Vue.config.productionTip = false

initConfig()
Vue.use(Laue)
Vue.use(window.VueCharts)
Vue.use(VueChartkick, {
  adapter: Chart
})
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false;
const isProduction = process.env.NODE_ENV === "production";

const options = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};
Vue.use(Vuebar);
Vue.use(VueLogger, options);
Vue.use(BootstrapVue);
Vue.use(VueSweetalert2);
Vue.use(JsonExcel)
Vue.use(Toasted, {
  duration: 2000
});

var baseURL = window.MKCL_HOST + "/server/"
// var baseURL = 'https://cs.mkcl.org/NaiTalim'
Vue.use(mqlOptions, {
  baseURL: baseURL
});
axios.defaults.baseURL = baseURL
// var baseURL = window.MKCL_HOST + "/server/";
// var baseURL = "http://localhost:8080/server/";
//var baseURL = "http://naitalim-stg.mkcl.org/server/";
// axios.defaults.baseURL = baseURL;
// TODO: set axios header on login  to session storage
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

// TODO: delete axios header on logout and clear session storage
// delete axios.defaults.headers.common['Authorization']
// Vue.use(mql, {
//   mqlBaseURL: baseURL,
//   versionEnable: false,
//   regionEnable: false
// });

Vue.use(VueLocalStorage);

router.beforeEach((to, from, next) => {
  loadLanguageAsync(to.meta.lang).then(() => next())

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  if (!nearestWithMeta) return next()
  nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta')
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })
      tag.setAttribute('data-vue-router-controlled', '')
      return tag
    })
    .forEach(tag => document.head.appendChild(tag))
  next()
})

axios.interceptors.request.use(
  function (config) {
    if (config.url.indexOf("/r/") !== -1) {
      // Check for restricted request
      if (config.headers.common["Authorization"]) {
        console.log("autorize!");
      } else {
        console.log("not authorize");
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

var vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");


function initConfig() {
  var url = window.location.href
  var arr = url.split('/')
  var result = arr[0] + '//' + arr[2]
  window.MKCL_HOST = result
}

window.app = vm;